import React, {useState, useEffect, useContext} from "react";
import {
  Button, VStack,
  HStack,
  Table,
  Tr,
  Td,
  Img,

  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Box,

} from '@chakra-ui/react';
import {useNavigate, Link} from "react-router-dom";
import {client, baseUrl} from "@/client"
import {GlobalContext, bearerToken, emptyUser} from "@/auth";

import './Coursewares.css';

import {
  Page,
  PageHeader,
  PageBody,
} from "@/components/layout"
import { Directory } from "@/pbgen/v1/main_pb";
import { forEach } from "jszip";

function drawTable(root: Directory, navigate: any) {
  return (
    <Table className="coursewares_table"><tbody>
    {root.files.map((f) =>
      <Tr className="coursewares_table_item">
        <Td key={f.path.join("/")} p={2} m={0}>
          <HStack>
          <Button className="coursewares_table_button" onClick={() => {navigate(`./${f.optCourseware?.projectId}`, {relative: "path"})}}>表示</Button>
          <Img className="coursewares_table_thumbnail" src={`${baseUrl}/scratch_api/assets/${f.optCourseware?.thumbnailId}`} />
          <span dangerouslySetInnerHTML={{ __html: f.optCourseware?.title ?? '' }}></span>
          </HStack>
        </Td>
      </Tr>
    )}
    {
      root.directories.map((d) =>
        <>
        <tr><td colSpan={2} className="coursewares_table_label">
        <span>{d.base}</span>
        </td></tr>
        <tr><td>{drawTable(d, navigate)}</td></tr>
        </>
      )
    }
    </tbody></Table>);
}

/*
function drawTree(root: Directory, navigate: any) {
  return (<UnorderedList>
    {root.files.map((f) =>
      <ListItem key={f.path.join("/")}>{f.base} <Button height={"1.1em"} onClick={() => {navigate(`./${f.optCourseware?.projectId}`, {relative: "path"})}}>表示</Button></ListItem>
    )}
    {
      root.directories.map((d) =>
        <>
          <ListItem>{d.base}</ListItem>
          {drawTree(d, navigate)}
        </>
      )
    }
  </UnorderedList>);
}
*/

function drawTabs(root: Directory, VendorId: string, navigate: any) {
  return (
    <Box>
      <Tabs variant="enclosed-colored">
        {/* タブリスト */}
        <TabList>
        {
          root.directories.map((d) =>
            <>
            <Tab key={'tab-${d.id}'}
              sx={{
              border: '1px #df6694 solid',
              background: 'white',
              _selected : { color: 'white', bg: '#df6694' },
              _hover : { bg: '#fdcbde' },
            }}
            >
              {(d.base === VendorId) ? "教材" : d.base}
            </Tab>
            </>
          )
        }
        </TabList>

        {/* タブのコンテンツ */}
        <TabPanels>
        {
          root.directories.map((d) =>
            <>
            <TabPanel p={0}>
              {drawTable(d, navigate)}
            </TabPanel>
            </>
          )
        }
        </TabPanels>
      </Tabs>
    </Box>
  );
}

export const Coursewares = () => {
  
  const [root, setRoot] = useState<Directory>(new Directory());
  const [currentUser, setCurrentUser] = useState("")
  const [ventorId, setVentorId] = useState("")
  const {globalState, setGlobalState} = useContext(GlobalContext);

  useEffect(() => {
    (async () => {

      const respv = await client.getVendors({
        bearerToken: bearerToken(),
      });
      if (!respv.currentUser) {
        navigate("/login", {relative: "path"});
        return;
      }
      if (respv.vendors.length === 0) {
        navigate("/manage", {relative: "path"});
        return
      }

      /*
      console.log("-------------------------------------");
      console.log(respv);
      console.log("-------------------------------------");
      console.log(respv.currentUser?.optName);
      console.log("-------------------------------------");
      console.log(respv.currentUser?.optVendorId);
      console.log("-------------------------------------");
      */

      setGlobalState({...globalState, currentUser: respv.currentUser ?? emptyUser()})
      setCurrentUser(respv.currentUser?.optName ?? "")
      setVentorId(respv.currentUser?.optVendorId ?? "")

      const resp = await client.getCoursewareTree(
        { 
          bearerToken: bearerToken(),
          userId: respv.currentUser.id,
        });

      if (! resp.root) {
        return
      }
      
      setRoot(resp.root);
    })();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const navigate = useNavigate();

  return <Page>
    <PageHeader title={"教材参照"}>
      <HStack padding={2}>
        {/* <Button onClick={() => {navigate("..", { relative: "path" })}}>戻る</Button> */}
        {/*<Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>戻る</Button>*/}
        <Button as={Link} to="/manage">メニューに戻る</Button>
      </HStack>
    </PageHeader>

    <PageBody>

      <VStack align={"center"}>
        {drawTabs(root, ventorId, navigate)}
      </VStack>

      {/*
      <VStack align={"center"}>
        {drawTable(root, navigate)}
      </VStack>
      */}

      </PageBody>
  </Page>
}
